import { FwaContentState } from "../../../../models/state";

const initialState: FwaContentState = {
    blocks: [],
};

const reducer = (state = initialState): FwaContentState => state;

export default reducer;
